import { render, staticRenderFns } from "./projectEditor.vue.html?vue&type=template&id=6d03ff45&"
import script from "./projectEditor.ts?vue&type=script&lang=ts&"
export * from "./projectEditor.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports